<terra-main-nav [showNav]="false" [showAccountActions]="false"></terra-main-nav>

<section class="container">
  <div class="inner-width">
    <div>
      <div *ngIf="confirmedSuccessful">
        <ng-container *ngIf="{logoData: referrerLogo$ | async} as referrer">
          <img class="referrer-logo" *ngIf="referrer?.logoData?.showLogo" [src]="referrer?.logoData?.logoUrl"/>
        </ng-container>
        <h1>Email Confirmed</h1>

        <p class="description" *ngIf="confirmedSuccessful">
          Your email is now confirmed.<br />
          return to <a [routerLink]="loginPageUrl" routerLinkActive="router-link-active">login page</a>
        </p>
      </div>

      <div *ngIf="confirmedError">
        <ng-container *ngIf="{logoData: referrerLogo$ | async} as referrer">
          <img class="referrer-logo" *ngIf="referrer?.logoData?.showLogo" [src]="referrer?.logoData?.logoUrl"/>
        </ng-container>
        <h1>An error has occurred</h1>
        <p class="description">
          {{errorMessage$ | async}} or<a target="_blank" mat-button href="//www.covercy.com/contact-us">contact support</a>
        </p>
      </div>
    </div>

    <terra-loader [centerToParent]="true" *ngIf="isLoading" />
  </div>
</section>
